<template>
    <teleport to="body">
        <div v-if="visible" class="note-context-backdrop" :class="{'note-context-backdrop--blur': compact}" :style="{zIndex: zBase + 9}" @click.stop="close" @touchend.stop.prevent="close" @contextmenu.stop.prevent="close"></div>
        <div v-if="visible" class="note-context-menu" :style="menuStyle" @click.stop @touchend.stop>
            <template v-if="type === 'note' && note">
                <template v-if="!note._isTemp">
                    <div class="context-menu-item" @click="handlePin">
                        <span class="context-menu-icon"><svg width="14" height="14" viewBox="0 0 24 24" :fill="note.is_pinned ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2"><path d="M9 4v6l-2 4h5v6l1-1 1 1v-6h5l-2-4V4"/><line x1="8" y1="4" x2="16" y2="4"/></svg></span>
                        <span>{{ note.is_pinned ? $t('pages.module.NOTE.contextMenu.unpin') : $t('pages.module.NOTE.contextMenu.pin') }}</span>
                    </div>
                </template>
                <div v-if="flatCategoryList.length > 0 || note.category" class="context-menu-item has-submenu" @mouseenter="showMoveSubmenu = true" @mouseleave="showMoveSubmenu = false" @click.stop="showMoveSubmenu = !showMoveSubmenu">
                    <span class="context-menu-icon">📂</span>
                    <span>{{ $t('pages.module.NOTE.contextMenu.moveTo') }}</span>
                    <span class="context-menu-arrow">›</span>
                    <div v-if="showMoveSubmenu" class="context-submenu" :class="submenuDirection" @click.stop>
                        <div v-if="note.category" class="context-menu-item" @click="handleMove(null)">
                            <span>{{ $t('pages.module.NOTE.contextMenu.uncategorized') }}</span>
                        </div>
                        <div v-for="cat in flatCategoryList" :key="cat.id" class="context-menu-item" :style="{paddingLeft: (12 + cat.depth * 16) + 'px'}" @click="handleMove(cat.id)">
                            <span class="category-color-dot" v-if="cat.color" :style="{background: cat.color}"></span>
                            <span>{{ cat.name }}</span>
                        </div>
                    </div>
                </div>
                <template v-if="!note._isTemp">
                    <div class="context-menu-item" @click="handleDuplicate">
                        <span class="context-menu-icon">📋</span>
                        <span>{{ $t('pages.module.NOTE.contextMenu.duplicate') }}</span>
                    </div>
                    <div class="context-menu-item" @click="handleShare">
                        <span class="context-menu-icon">👥</span>
                        <span>{{ $t('pages.module.NOTE.contextMenu.share') }}</span>
                    </div>
                </template>
                <div class="context-menu-divider"></div>
                <div class="context-menu-item context-menu-item--danger" @click="handleDelete">
                    <span class="context-menu-icon">🗑️</span>
                    <span>{{ $t('pages.module.NOTE.contextMenu.delete') }}</span>
                </div>
            </template>

            <template v-if="type === 'tag' && tag">
                <div class="context-menu-item context-menu-item--danger" @click="handleDeleteTag">
                    <span class="context-menu-icon">🗑️</span>
                    <span>{{ $t('btn.delete') }}</span>
                </div>
            </template>

            <template v-if="type === 'category' && category">
                <div class="context-menu-item" @click="handleRename">
                    <span class="context-menu-icon">✏️</span>
                    <span>{{ $t('pages.module.NOTE.contextMenu.rename') }}</span>
                </div>
                <div class="context-menu-item" @click="handleNewSubCategory">
                    <span class="context-menu-icon">📁</span>
                    <span>{{ $t('pages.module.NOTE.contextMenu.newSubCategory') }}</span>
                </div>
                <div class="context-menu-item has-submenu" @mouseenter="showColorSubmenu = true" @mouseleave="showColorSubmenu = false" @click.stop="showColorSubmenu = !showColorSubmenu">
                    <span class="context-menu-icon">🎨</span>
                    <span>{{ $t('pages.module.NOTE.contextMenu.changeColor') }}</span>
                    <span class="context-menu-arrow">›</span>
                    <div v-if="showColorSubmenu" class="context-submenu" :class="submenuDirection" @click.stop>
                        <div class="context-color-grid">
                            <div v-for="color in noteColors" :key="color.id"
                                 class="context-color-dot"
                                 :style="{background: color.hex}"
                                 :title="color.label"
                                 @click="handleCategoryColor(color.hex)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="context-menu-divider"></div>
                <div class="context-menu-item context-menu-item--danger" @click="handleDeleteCategory">
                    <span class="context-menu-icon">🗑️</span>
                    <span>{{ $t('btn.delete') }}</span>
                </div>
            </template>
        </div>
    </teleport>
</template>

<script>
const NOTE_COLORS = [
    {id: 'red', hex: '#FF3B30', label: 'Kırmızı'},
    {id: 'orange', hex: '#FF9500', label: 'Turuncu'},
    {id: 'yellow', hex: '#FFCC00', label: 'Sarı'},
    {id: 'green', hex: '#34C759', label: 'Yeşil'},
    {id: 'blue', hex: '#007AFF', label: 'Mavi'},
    {id: 'purple', hex: '#AF52DE', label: 'Mor'},
    {id: 'pink', hex: '#FF2D55', label: 'Pembe'},
    {id: 'gray', hex: '#8E8E93', label: 'Gri'},
]

export default {
    name: 'NoteContextMenu',
    props: {
        categoryTree: {type: Array, default: () => []},
        compact: {type: Boolean, default: false},
        zBase: {type: Number, default: 100000},
    },
    data() {
        return {
            visible: false,
            type: 'note',
            note: null,
            category: null,
            tag: null,
            x: 0,
            y: 0,
            showMoveSubmenu: false,
            showColorSubmenu: false,
            noteColors: NOTE_COLORS,
        }
    },
    computed: {
        menuStyle() {
            return {
                position: 'fixed',
                left: this.x + 'px',
                top: this.y + 'px',
                zIndex: this.zBase + 10,
            }
        },
        submenuDirection() {
            return (this.x + 400) > window.innerWidth ? 'submenu-left' : 'submenu-right'
        },
        flatCategoryList() {
            const result = []
            const currentCategoryId = this.note?.category?.id || null
            const flatten = (items, depth = 0) => {
                for (const item of items) {
                    if (item.id !== currentCategoryId) {
                        result.push({id: item.id, name: item.name, color: item.color, depth})
                    }
                    if (item.children && item.children.length) flatten(item.children, depth + 1)
                }
            }
            flatten(this.categoryTree)
            return result
        },
    },
    methods: {
        openForNote(event, note) {
            this.removeCloseListeners()
            this.type = 'note'
            this.note = note
            this.category = null
            this.tag = null
            this.showMoveSubmenu = false
            this.showColorSubmenu = false
            this.setPosition(event)
            this.visible = true
            this.addCloseListeners()
        },
        openForCategory(event, category) {
            this.removeCloseListeners()
            this.type = 'category'
            this.category = category
            this.note = null
            this.tag = null
            this.showMoveSubmenu = false
            this.showColorSubmenu = false
            this.setPosition(event)
            this.visible = true
            this.addCloseListeners()
        },
        openForTag(event, tag) {
            this.removeCloseListeners()
            this.type = 'tag'
            this.tag = tag
            this.note = null
            this.category = null
            this.showMoveSubmenu = false
            this.showColorSubmenu = false
            this.setPosition(event)
            this.visible = true
            this.addCloseListeners()
        },
        setPosition(event) {
            const menuWidth = 200
            const menuHeight = 250
            let x = event.clientX
            let y = event.clientY
            if (x + menuWidth > window.innerWidth) x = window.innerWidth - menuWidth - 10
            if (y + menuHeight > window.innerHeight) y = window.innerHeight - menuHeight - 10
            this.x = x
            this.y = y
        },
        close() {
            this.visible = false
            this.showMoveSubmenu = false
            this.showColorSubmenu = false
            this.removeCloseListeners()
        },
        addCloseListeners() {
            document.addEventListener('keydown', this.onEsc)
        },
        removeCloseListeners() {
            document.removeEventListener('keydown', this.onEsc)
        },
        onEsc(e) {
            if (e.key === 'Escape') this.close()
        },
        handlePin() {
            this.$emit('pin', this.note)
            this.close()
        },
        handleMove(categoryId) {
            this.$emit('move', {note: this.note, categoryId})
            this.close()
        },
        handleDuplicate() {
            this.$emit('duplicate', this.note)
            this.close()
        },
        handleShare() {
            this.$emit('share', this.note)
            this.close()
        },
        handleDelete() {
            this.$emit('delete', this.note)
            this.close()
        },
        handleRename() {
            this.$emit('renameCategory', this.category)
            this.close()
        },
        handleNewSubCategory() {
            this.$emit('newSubCategory', this.category)
            this.close()
        },
        handleCategoryColor(hex) {
            this.$emit('categoryColor', {category: this.category, color: hex})
            this.close()
        },
        handleDeleteCategory() {
            this.$emit('deleteCategory', this.category)
            this.close()
        },
        handleDeleteTag() {
            this.$emit('deleteTag', this.tag)
            this.close()
        },
    },
    beforeUnmount() {
        this.removeCloseListeners()
    }
}
</script>

<style>
.note-context-backdrop {
    position: fixed;
    inset: 0;
    z-index: 100009;
}

.note-context-backdrop--blur {
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    background: rgba(0, 0, 0, 0.15);
}

.note-context-menu {
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 8px;
    padding: 4px 0;
    min-width: 180px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
    font-size: 13px;
    user-select: none;
}

.context-menu-item {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    cursor: pointer;
    color: #1c1c1e;
    position: relative;
    gap: 8px;
    white-space: nowrap;
}

.context-menu-item:hover {
    background: rgba(var(--panel-accent-rgb), 0.08);
}

.context-menu-item--danger {
    color: #FF3B30;
}

.context-menu-icon {
    width: 18px;
    text-align: center;
    font-size: 14px;
}

.context-menu-arrow {
    margin-left: auto;
    opacity: 0.5;
}

.context-menu-divider {
    height: 1px;
    background: #e5e5ea;
    margin: 4px 0;
}

.context-submenu {
    position: absolute;
    top: -4px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 8px;
    padding: 4px 0;
    min-width: 160px;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.context-submenu.submenu-right {
    left: 100%;
    margin-left: 2px;
}

.context-submenu.submenu-left {
    right: 100%;
    margin-right: 2px;
}

.submenu-child {
    padding-left: 28px !important;
}

.category-color-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.context-color-grid {
    display: flex;
    gap: 6px;
    padding: 8px 12px;
    flex-wrap: wrap;
}

.context-color-dot {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    transition: transform 0.15s;
}

.context-color-dot:hover {
    transform: scale(1.2);
}

html.dark .note-context-backdrop--blur {
    background: rgba(0, 0, 0, 0.3);
}

html.dark .note-context-menu {
    background: #1E2027;
    border-color: #26272F;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2);
}

html.dark .context-menu-item {
    color: #F5F5F5;
}

html.dark .context-menu-item:hover {
    background: rgba(16, 185, 129, 0.12);
}

html.dark .context-menu-item--danger {
    color: #FF453A;
}

html.dark .context-menu-divider {
    background: #26272F;
}

html.dark .context-submenu {
    background: #1E2027;
    border-color: #26272F;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
}

html.midnight .note-context-backdrop--blur {
    background: rgba(0, 0, 0, 0.3);
}

html.midnight .note-context-menu {
    background: #241F1B;
    border-color: #2C2823;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2);
}

html.midnight .context-menu-item {
    color: #EAE6E1;
}

html.midnight .context-menu-item:hover {
    background: rgba(200, 134, 60, 0.12);
}

html.midnight .context-menu-divider {
    background: #2C2823;
}

html.midnight .context-submenu {
    background: #241F1B;
    border-color: #2C2823;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
}
</style>
